<template lang="pug">
  #app
    transition(name="slide")
      keep-alive
        router-view
    pending(v-if="pending")
</template>
<script>
import AlipayService from '@/services/AlipayService'
import { mapState } from 'vuex'
import Pending from '@/components/wedgits/Pending'
export default {
  name: 'App',
  components: { Pending },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['router', 'pending']),
  },
  mounted() {
    AlipayService.on(AlipayService.Events.ONMESSAGE, this.onmessage)
  },
  methods: {
    onmessage(e) {
      if (e.msg === 'back' && this.$route.path !== this.router.back) {
        this.$router.replace(this.router.back)
      }
    },
  },
}
</script>

<style lang="sass">
@import "src/styles/base.sass"
#app

.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
